import React from 'react'
import styled from 'styled-components' 

export default function OpenResponses({ pollData }) {
    return (
        <>
            {
                pollData.responses.map((response, index) => (
                    <OpenResponseItemContainer key={index}> 
                        <UserWrap>
                            <ProfilePic src={response.user.profileImg.url} />
                            <UserName >
                                {response.user.fullName ? response.user.fullName : "user"} - {response.user.email}
                            </UserName> 
                        </UserWrap>

                        <ResponseText >
                            {response.response}
                        </ResponseText>
                    </OpenResponseItemContainer>
                ))
            }
        </>
    )
}

const UserWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
`

const ProfilePic = styled.img`
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 5px;
`

const UserName = styled.div`
    width: 100%; 
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start; 
    color: var(--lightThemeFontColor);
    z-index: 0;
    font-size: 14px;
    font-weight: 500;
    padding: 10px;
`

const OpenResponseItemContainer = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start; 
    color: var(--lightThemeFontColor);
    z-index: 0;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;

`

const ResponseText = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start; 
    color: var(--lightThemeFontColor);
    z-index: 0;
`